import i18n from '@/i18n';

export default [
  {
    path: '/packages',
    name: 'packages',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'package',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('packages')
    },
    // route level code-splitting
    component: () => import('../../views/packages/Index'),
    children: [
      {
        path: 'new',
        name: 'packages-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'package',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('packages'),
        },
        component: () => import('../../views/packages/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'packages-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'package',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('packages'),
        },
        component: () => import('../../views/packages/Edit.vue'),
      },
    ],
  },
];
